import React from 'react';
import { useTranslation } from 'react-i18next';
import '../v2/pages/timesheet/timeSheetsPage/timeSheetsPage.scss';

interface TimesheetFilterHeaderProps {
  fromDate: string;
  toDate: string;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
  onLoad: () => void;
  onSave: () => void;
  placeholder?: string;
  hasNewEntries?: boolean;
}

const TimesheetFilterHeader: React.FC<TimesheetFilterHeaderProps> = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  placeholder = "YYYY-MM-DD",
  onLoad,
  onSave,
  hasNewEntries = false,
}) => {
  const { t } = useTranslation();
  
  const isLoadDisabled = (!fromDate && !!toDate) || (!!fromDate && !toDate);
  
  return (
    <div className="timesheet-filter-header">
      <div className="filter-field">
        <label className="filter-label" style={{ color: "var(--text-icons-light-base-main, #252525)", fontFamily: "Plus Jakarta Sans", fontSize: 14, fontStyle: "normal", fontWeight: 500, lineHeight: "20px", marginBottom: "0px !important" }}>
          {t("FROMS")}
        </label>
        <div className="filter-input-wrapper">
          <input
            type="date"
            className="filter-input"
            value={fromDate}
            onChange={(e) => onFromDateChange(e.target.value)}
            placeholder={placeholder}
          />
        </div>
      </div>

      <div className="filter-field">
        <label className="filter-label" style={{ color: "var(--text-icons-light-base-main, #252525)", fontFamily: "Plus Jakarta Sans", fontSize: 14, fontStyle: "normal", fontWeight: 500, lineHeight: "20px", marginBottom: "0px !important" }}>
          {t("TO")}
        </label>
        <div className="filter-input-wrapper">
          <input
            type="date"
            className="filter-input"
            value={toDate}
            onChange={(e) => onToDateChange(e.target.value)}
            min={fromDate || undefined}
            placeholder={placeholder}
          />
        </div>
      </div>

      <button
        className={`load-btn ${isLoadDisabled ? "disabled" : ""}`}
        onClick={onLoad}
        disabled={isLoadDisabled}
        style={{
          opacity: isLoadDisabled ? 0.5 : 1,
          cursor: isLoadDisabled ? "not-allowed" : "pointer",
        }}
      >
        {t("LOAD")}
      </button>

      <button className="save-timesheet-btn" onClick={onSave} disabled={!hasNewEntries}>
        {t("SAVE_TIMESHEET")}
      </button>
    </div>
  );
};

export default TimesheetFilterHeader;
